import { axiosInstance } from '~/services';

import type {
  TypeGetOwnerSupplierManagerOwnerSupplierCodeListParams,
  TypeGetOwnerSupplierManagerOwnerSupplierCodeListResponse,
} from '~/types/vender.types';

/**
 * [화주사정보관리 > 공급사관리] 담당자 목록 조회
 */
const useGetOwnerSupplierManagerOwnerSupplierCodeList = () => {
  const endPoint = '/api-owner/owner-supplier-manager';

  const getOwnerSupplierManagerOwnerSupplierCodeList = async ({
    ownerSupplierCode,
  }: TypeGetOwnerSupplierManagerOwnerSupplierCodeListParams) => {
    return axiosInstance
      .get<TypeGetOwnerSupplierManagerOwnerSupplierCodeListResponse>(`${endPoint}/${ownerSupplierCode}/list`)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error) => {
        throw error;
      });
  };

  return { getOwnerSupplierManagerOwnerSupplierCodeList };
};

export default useGetOwnerSupplierManagerOwnerSupplierCodeList;
